<template>
	<!-- Main Sections -->
	<main class="main-wrapper">

			<!-- Title Banner Start -->
			<section class="title-banner">
			<div class="container-fluid">
				<div class="banner-wrapper">
					<img src="/assets/media/banner/left-image.png" alt="" class="banner-image1">
					<h1 class="dark-black fw-600">Каталог товаров</h1>
					<img src="/assets/media/banner/right-image.png" alt="" class="banner-image2">
				</div>
			</div>
		</section>
		<!-- Title Banner End -->

		<!-- Featured Product Start -->
		<section class="featured-product-sec py-40 bg-lightest-gray">
			<div class="container-fluid">
				<div class="row row-gap-3">
					<div class="col-xl-3">
						<div class="sidebar bg-white">
							<div class="category-block box-1 mb-24">
								<div class="title mb-24" data-count="1">
									<h6>Категории</h6>
								</div>
								<div class="content-block">
									<category-tree :categories="categoryTree" v-model:selected="selectedCategories" />
								</div>
							</div>
							<div class="hr-line mb-24"></div>
							<router-link :to="{path: '/catalog/4'}" class="main-card">
								<h4 class="fw-500 white mb-32">Специальное предложение</h4>
								<div class="image mb-32">
									<img src="/assets/media/products/main-image.png" alt="">
								</div>
								<h5 class="fw-500 white mb-16 text-center">Gamepad Game Controller</h5>
								<h5 class="fw-500 white text-center">90 000 тг</h5>
							</router-link>
						</div>
					</div>
					<div class="col-xl-9">
						<div class="shop-grid-topbar mb-16">
							<div class="first-block">
								<div class="results d-lg-block d-none">
									<p class="dark-gray">Товаров: {{products_count}}</p>
								</div>
							</div>
							<div class="last-block">
								<div class="d-lg-flex d-none align-items-center gap-8">
									<p class="dark-gray">Сортировка:</p>
									<select class="form-select" v-model="sort">
										<option value="default">По умолчанию</option>
										<option value="price_asc">Сначала дешевле</option>
										<option value="price_desc">Сначала дороже</option>
									</select>
									
								</div>
							</div>
						</div>
						<div class="row row-gap-3">
							<div class="col-xl-4 col-lg-4 col-md-6" v-for="product in products" :key="product.id">
								<div class="featured-product-card bg-white br-10">
									<div class="image-box mb-16" style="height: 300px;">
										<!--<span class="sale-label">-12%</span>-->
										<router-link :to="{path: '/catalog/'+product.id}" class="h-100">
											<img :src="product.poster" class="product-image" alt="">
										</router-link>
										<div class="side-icons">
											<ul class="list-unstyled">
												<li>
													<a href="#" @click.prevent="appModel.toggleProductWishlist(product)" class="btn">
														<svg v-if="!appModel.hasProductInWishlist(product.id)" width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z" /></svg>
														<svg v-else width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" /></svg>
													</a>
												</li>
												<!--
												<li>
													<a href="#" class="btn" data-bs-toggle="modal" data-bs-target="#productQuickView">
														<img src="/assets/media/icons/eye.png" alt="">
													</a>
												</li>
												-->
											</ul>
										</div>
									</div>
									<div class="product-desc">
										<h6 class="product-title mb-8">
											<router-link :to="{path: '/catalog/'+product.id}">{{product.name}}</router-link>
										</h6>
										<div class="rating-star mb-16 bg-white">
											<h6>
												<span class="text-decoration-line-through light-gray pe-2" v-if="product.oldPrice">{{number_format(product.oldPrice)}} тг</span>
												<span>{{number_format(product.price)}} тг</span>
											</h6>
										</div>
										<a href="#" @click.prevent="appModel.toggleProductBasket(product)" class="w-100" :class="{'cus-btn-2': !appModel.hasProductInBasket(product.id), 'cus-btn-3': appModel.hasProductInBasket(product.id)}">
											<span v-if="!appModel.hasProductInBasket(product.id)">В корзину</span>
											<span v-else>Убрать из корзины</span>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div class="pagination pt-40">
							<ul id="border-pagination">
								<li v-if="page > 1">
									<a href="#" @click.prevent="gotoPage(page - 1)">
										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
											<path d="M9.48438 17.25C9.48438 15 7.38438 12 4.98438 12M4.98438 12C6.35938 12 9.48437 11.25 9.48438 6.75M4.98438 12H19.2344" stroke="#141516" stroke-width="1.5"></path>
										</svg>
									</a>
								</li>
								<li><a href="#" :class="{'active': page == 1}" @click.prevent="gotoPage(page - 1)">1</a></li>
								<li v-if="page - paginationAlpha > 2">
									<span>...</span>
								</li>
								<li v-for="i in range(paginationA1, paginationA2)" :key="i" v-show="paginationA2 >= paginationA1">
									<a href="#" :class="{'active': page == i}" @click.prevent="gotoPage(i)">{{i}}</a>
								</li>
								<li v-if="page + paginationAlpha < getPagesCount() - 1">
									<span>...</span>
								</li>
								<li v-if="getPagesCount() > 1">
									<a href="#" :class="{'active': page == getPagesCount()}" @click.prevent="gotoPage(getPagesCount())">{{getPagesCount()}}</a>
								</li>
								<li v-if="page < getPagesCount()">
									<a href="#" @click.prevent="gotoPage(page + 1)">
										<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
											<path
												d="M20.1953 22.9995C20.1953 19.9995 22.9953 15.9995 26.1953 15.9995M26.1953 15.9995C24.362 15.9995 20.1953 14.9995 20.1953 8.99951M26.1953 15.9995H7.19531"
												stroke="#282525" stroke-width="2" />
										</svg>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- Featured Product End -->

		<benefits />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';
import CategoryTree from '@/components/CategoryTree';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		search: '',
		
		selectedCategories: [],
		sort: 'default',
		
		products: [],
		products_count: 0,
		
		page: 1,
		limit: 9,
		loading: true,
		error: '',
		
		paginationAlpha: 3,
	}),
	watch: {
		selectedCategories: {
			handler(){
				this.page = 1;
				this.loadData();
			},
			deep: true,
		},
		search: {
			handler(){
				this.page = 1;
				this.loadData();
			},
		},
		sort: {
			handler(){
				this.page = 1;
				this.loadData();
			},
		},
	},
	computed: {
		categoryTree() {
			return this.buildTree(this.appModel.productsCategories);
		},
		
		paginationA1(){
			return Math.max(this.page - this.paginationAlpha, 2);
		},
		paginationA2(){
			return Math.min(this.page + this.paginationAlpha, this.getPagesCount() - 1);
		},
	},
	methods: {
		range: lib.range,
		number_format(value){
			return lib.number_format(value, 0, '.', ' ');
		},
		
		buildTree(categories, parentId = null){
			return categories
				.filter(cat => cat.parent_id === parentId)
				.map(cat => ({
					...cat,
					children: this.buildTree(categories, cat.id)
				}));
		},
		
		async loadData(){
			this.loading = true;
			this.error = '';
			let params = {
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			if(this.search){
				params['search'] = this.search;
			}
			if(this.selectedCategories.length){
				params['filter'] = [
					{
						field: 'p.category_id',
						operator: '=',
						value: this.selectedCategories,
					}
				];
			}
			if(this.sort == 'price_asc'){
				params['sort'] = [
					{
						field: 'p.price',
						direction: 'asc',
					}
				];
			} else if(this.sort == 'price_desc'){
				params['sort'] = [
					{
						field: 'p.price',
						direction: 'desc',
					}
				];
			}
			const ret = await this.appModel.doGetProducts(params);
			if(ret.success){
				this.products = ret.list;
				this.products_count = ret.count;
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
		
		gotoPage(page){
			if(page >= 1 && page <= this.getPagesCount() && page != this.page){
				this.page = page;
				this.loadData();
				window.scrollTo(0, 0);
			}
		},
		// получение количества страниц
		getPagesCount(){
			return Math.ceil(this.products_count / this.limit);
		},
	},
	async mounted(){
		window.scrollTo(0, 0);
		
		if (this.$route.query.categories) {
			for (const cat of this.$route.query.categories) {
				this.selectedCategories.push(parseInt(cat));
			}
		}
		if (this.$route.query.search) {
			this.search = this.$route.query.search;
		}
		
		await this.loadData();
	},
	beforeRouteUpdate(to, from, next){
		const oldCategories = from.query.categories;
		const newCategories = to.query.categories;

		if (JSON.stringify(oldCategories) !== JSON.stringify(newCategories)) {
			this.selectedCategories = [];
			for (const cat of newCategories) {
				this.selectedCategories.push(parseInt(cat));
			}
		}
		if (from.query.search !== to.query.search) {
			this.search = to.query.search;
		}
		
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits,
		CategoryTree,
	},
};
</script>